const storefront = "330f1043f7723b14b0a7be7daaaf2bbf"
const apiEndpoint = `https://vicis-pro.myshopify.com/api/2025-04/graphql.json`;
const customHelmetVariantID = "45004914622690"
const targetPriceProductID = "8357438652642"
async function getVariantPrice() {
  try {
    const query = `
      query {
        product(id: "gid://shopify/Product/${targetPriceProductID}") {
          variants(first: 100) {
            edges {
              node {
                id
                priceV2 {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    `;

    const response = await fetch(apiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefront,
      },
      body: JSON.stringify({ query }),
    });

    const data = await response.json();
    
    if (data.errors) {
      throw new Error(data.errors[0].message);
    }

    if (!data.data?.product?.variants?.edges) {
      throw new Error('Product not found or has no variants');
    }

    // Transform the data into a more usable format
    return data.data.product.variants.edges.map(({ node }) => ({
      id: node.id,
      price: node.priceV2,
    }));
  } catch (error) {
    console.error('Error fetching variant prices:', error);
    throw error;
  }
}

async function customAddToCart(submitButtons, productForm) {
  console.log("custom add to cart running...")
  const price = helper.getAddonsPrice();
  console.log("price", price)
  console.log("product_lead_time", product_lead_time)
  const variantPriceList = await getVariantPrice();
  console.log("variantPriceList", variantPriceList)
  const targetVariantID = variantPriceList.find((itm) => itm.price.amount === price.toString());
  if(targetVariantID) {
    formData.set('id', targetVariantID.id.replace("gid://shopify/ProductVariant/", ""))
  } else {
    console.error("price on variant is not found")
  }
  
  console.log("targetVariantID", targetVariantID)
}






